import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/dashboard/_trucks/caminhoes/marcas/editar/$id")({
  component: Outlet,
  params: {
    parse: (val) => ({ id: +val.id })
  }
});
